import { workflowComponent } from '@banking/ui/services/bank-accounts';
import { hbs } from 'ember-cli-htmlbars';
import { goNextPageDisabled, goPrevPageDisabled, userClickNextPageAction, userClickPrevPageAction } from '@banking/ui/workflows/bank-accounts/external-bank-accounts';
const template = hbs`
  <Banking::BankAccounts::ExternalBankAccounts
    @merchantBankAccounts={{this.merchantBankAccounts}}
    @externalBankAccountsHeadingTitle={{this.externalBankAccountsHeadingTitle}}
    @currentPageNumber={{this.currentPageNumber}}
    @goLeft={{this.goLeft}}
    @goLeftDisabled={{this.goLeftDisabled}}
    @goRight={{this.goRight}}
    @goRightDisabled={{this.goRightDisabled}}
    @lastPageNumber={{this.lastPageNumber}}
    @showPagination={{this.showPagination}}
  />`;
const mapStateToProps = state => ({
  currentPageNumber: state.externalBankAccounts.currentPage,
  goLeftDisabled: goPrevPageDisabled(state.externalBankAccounts),
  goRightDisabled: goNextPageDisabled(state.externalBankAccounts),
  lastPageNumber: state.externalBankAccounts.lastPage,
  showPagination: state.externalBankAccounts.showPagination,
  merchantBankAccounts: state.externalBankAccounts.displayedRows,
  externalBankAccountsHeadingTitle: state.externalBankAccounts.externalBankAccountsHeadingTitle
});
const mapActionsToProps = () => ({
  goLeft: userClickPrevPageAction,
  goRight: userClickNextPageAction
});
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);